import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';
import { CoreLink } from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';

import { DOMAIN_AMSTERDAMUNDERGROUND } from '../../config/constants';

const NotFound = () => {
  const {
    t,
  } = useTranslation();

  const currentDomainIsAmsterdamUnderground = config.get('CURRENT_DOMAIN') === DOMAIN_AMSTERDAMUNDERGROUND;

  return (
    <article className="not-found-page">
      <div className="row">
        <div className="not-found-page__title col-12 col-md-8 offset-md-2">
          <h1>{t('page_not_found.title')}</h1>
        </div>

        <div className="not-found-page__body col-12 col-md-8 offset-md-2">
          {t('page_not_found.body')}
        </div>

        <div className="not-found-page__buttons col-12 col-md-8 offset-md-2">
          <CoreLink href="/" className="Button Button--primary">{t('page_not_found.primary_button_text')}</CoreLink>
          {!currentDomainIsAmsterdamUnderground && <CoreLink href="/" className="Button Button--secondary">{t('page_not_found.secondary_button_text')}</CoreLink>}
        </div>
      </div>
    </article>
  );
};

export default NotFound;
